<template>
    <div>
        <b-container class="container-panel">
            <b-card no-body>
                <b-card-header><h3>{{paymentHeaderText}}</h3></b-card-header>
                <b-card-body>
                    <div v-if="!depositInfo.hasDeposit">
                        <input type="checkbox" v-model="isPayLaterBox" />
                        <span>Payment will be received by ACE/Money Gram</span>
                    </div>
                    <b-row>
                        <div class="mx-2">
                            <b-button v-if="!isPayLaterBox" class="mt-3" @click="payNow">Pay First Installment Now</b-button>
                        </div>
                        <div class="mx-2">
                            <b-button v-if="isPayLaterBox" class="mt-3" @click="payLater">Pay Later</b-button>
                        </div>
                        <div class="mx-2">
                            <b-button class="mt-3" @click="cancel">Cancel</b-button>
                        </div>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-container>
    </div>
</template>
<script>
    import Repo from '../repo';
    export default {
        name: 'PaymentPlanPay',
        props: {
            createPaymentPlanRequest: Object,
            permissions: Array,
            user: String,
            depositInfo: Object
        },
        data() {
            return {
                isPayLaterBox: false
            }
        },
        mounted: async function () {
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
        },
        methods: {
            payNow: async function () {
                this.savePaymentPlan();
                await new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetCustomerInfo({
                        CustomerNumber: this.$route.params.customerNumber,
                    }).then(res => {
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                        //save payment plan here
                        console.log("Request 1");
                        console.log(this.createPaymentPlanRequest);
                        const request = {
                            Amount: this.createPaymentPlanRequest.installments[0].totalDueNowAmount,
                            ExternalKeyType: "CUSTOMER",
                            ExternalKeyValue: res.accountNumber,
                            AccountHolderName: res.customer.firstName + " " + res.customer.lastName,
                            PaymentCampaignCode: "PAYMENTPLAN",
                            DisplayLanguageOptions: ["en", "sp"],
                            CountryCode: "US",
                        }
                        this.$store.dispatch("lobby/getPaymentToken", request);
                    });
                });
                return;
            },
            payLater: async function () {
                await this.savePaymentPlan();
                this.$emit('close');
                return;
            },
            savePaymentPlan: async function () {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.SavePaymentPlan({
                        customerNbr: this.$route.params.customerNumber,
                        amount: this.createPaymentPlanRequest.amount,
                        installments: this.createPaymentPlanRequest.installments,
                        invoices: this.createPaymentPlanRequest.invoices,
                        name: this.createPaymentPlanRequest.name,
                        paymentPlanTypeCode: 2,
                        notes: this.createPaymentPlanRequest.notes,
                        emailAgreementTo: '',
                        userUpdate: this.user,
                        appUpdate: 'PaymentPlan'
                    }).then(res => {
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            cancel() {
                this.$emit('close');
                return;
            }
        },
        computed: {
            paymentHeaderText: function () {
                var text = "";
                if (this.depositInfo.hasDeposit == true) {
                    var text = "Select To Pay Now";
                } else {
                    var text = "Select To Pay Now Or Later";
                }
                return text;
            }
        },
        watch: {
            permissions: function (newVal, oldVal) { }
        }
    };
</script>
